import decode from "jwt-decode";
import ServiceBase from "../../ServiceBase";

export default class AuthService extends ServiceBase {
  // Initializing important variables
  constructor(domain) {
    super(domain);
    this.login = this.login.bind(this);
    this.getProfile = this.getProfile.bind(this);
  }

  async login(username, password) {
    if (!username?.trim() || !password?.trim()) {
      return Promise.reject({
        message: "Please enter a username and password."
      });
    }

    // Get a token from api server using the fetch api
    const res = await this.fetch(`${this.domain}/login`, {
      method: "POST",
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    });

    // Store profile token and login time
    this.setToken(res.token);
    this.setLastLoginTime(Date.now());

    // Restart token expiration checker
    this.debounceExpiration();
    return res;
  }

  getProfile() {
    // Using jwt-decode npm package to decode the token
    return decode(this.getToken());
  }

  getRoles() {
    var payload = decode(this.getToken());
    return payload["roles"];
  }

  isAdmin() {
    var roles = [];
    roles.push("ROLE_ADMIN");
    roles.push("ROLE_SUPER_ADMIN");
    roles.push("ROLE_CONTENT_MANAGER");
    roles.push("ROLE_CLASS_STREAMING");

    var userRoles = this.getRoles();
    return roles.some((r) => userRoles.includes(r));
  }
}
